import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName } from '../../constants';

export class GATrackingPdpFurtherInformationInteractionEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): any {
    return this.payload.action;
  }

  getPayload(): GATrackingEventPayload {
    return { 
      event: GaTrackingEventName.PdpFurtherInformationClick,
      label: this.payload.label,
      gtmCustom: {
        category: this.payload.category
      }
    };
  }
}
